// assets/local-store.js

class LocalStore {
  constructor(prefix = 'app_') {
    this.prefix = prefix // opcional, para evitar colisiones
  }

  /**
   * @param {string} key
   */
  _key(key) {
    return `${this.prefix}${key}`
  }

  /**
   * @param {string} key
   * @param {any} value
   */
  // Guardar valor
  set(key, value) {
    try {
      const data = JSON.stringify(value)
      localStorage.setItem(this._key(key), data)
    } catch (err) {
      console.error('LocalStore.set error:', err)
    }
  }

  /**
   * @param {string} key
   */
  // Leer valor
  get(key, defaultValue = null) {
    try {
      const item = localStorage.getItem(this._key(key))
      return item ? JSON.parse(item) : defaultValue
    } catch (err) {
      console.error('LocalStore.get error:', err)
      return defaultValue
    }
  }

  /**
   * @param {string} key
   */
  // Eliminar un valor
  remove(key) {
    try {
      localStorage.removeItem(this._key(key))
    } catch (err) {
      console.error('LocalStore.remove error:', err)
    }
  }

  // Limpiar todo (solo con tu prefix)
  clear() {
    Object.keys(localStorage)
      .filter((k) => k.startsWith(this.prefix))
      .forEach((k) => localStorage.removeItem(k))
  }
}

const localStore = new LocalStore('nomad_')

export default localStore
